"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.SplitButtonTextWrapper = exports.SectionHeading = exports.ResetButton = exports.ReportSummaryWrapper = exports.HelpButton = exports.GenerateBtnArea = exports.FlexReportAreaWrapper = exports.ExportType = exports.DropDownWrapper = exports.DateFilterWrapper = exports.ButtonWrapper = exports.AlertOrderDateCompatibleWrapper = exports.AlertNoReportAvailable = exports.AlertMessageWrapper = void 0;
require("core-js/modules/es6.string.small.js");
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _get = _interopRequireDefault(require("lodash/get"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _ReportDateFilter = _interopRequireDefault(require("./ReportDateFilter"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;
function cov_ul1gwc062() {
  var path = "/codebuild/output/src1366864877/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/ReportManagement/lib/Styling.js";
  var hash = "3b4528e91152aea9d51e3c85d6c69c0d80da2019";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1366864877/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/ReportManagement/lib/Styling.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 47
        },
        end: {
          line: 7,
          column: 63
        }
      },
      "1": {
        start: {
          line: 9,
          column: 23
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "2": {
        start: {
          line: 31,
          column: 37
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "3": {
        start: {
          line: 34,
          column: 20
        },
        end: {
          line: 34,
          column: 41
        }
      },
      "4": {
        start: {
          line: 46,
          column: 31
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "5": {
        start: {
          line: 57,
          column: 29
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "6": {
        start: {
          line: 58,
          column: 22
        },
        end: {
          line: 58,
          column: 76
        }
      },
      "7": {
        start: {
          line: 70,
          column: 26
        },
        end: {
          line: 70,
          column: 56
        }
      },
      "8": {
        start: {
          line: 84,
          column: 26
        },
        end: {
          line: 87,
          column: 1
        }
      },
      "9": {
        start: {
          line: 89,
          column: 30
        },
        end: {
          line: 105,
          column: 1
        }
      },
      "10": {
        start: {
          line: 107,
          column: 31
        },
        end: {
          line: 123,
          column: 1
        }
      },
      "11": {
        start: {
          line: 108,
          column: 22
        },
        end: {
          line: 108,
          column: 69
        }
      },
      "12": {
        start: {
          line: 125,
          column: 38
        },
        end: {
          line: 130,
          column: 1
        }
      },
      "13": {
        start: {
          line: 132,
          column: 35
        },
        end: {
          line: 143,
          column: 1
        }
      },
      "14": {
        start: {
          line: 145,
          column: 38
        },
        end: {
          line: 150,
          column: 1
        }
      },
      "15": {
        start: {
          line: 152,
          column: 47
        },
        end: {
          line: 158,
          column: 1
        }
      },
      "16": {
        start: {
          line: 160,
          column: 36
        },
        end: {
          line: 175,
          column: 1
        }
      },
      "17": {
        start: {
          line: 177,
          column: 27
        },
        end: {
          line: 200,
          column: 1
        }
      },
      "18": {
        start: {
          line: 190,
          column: 22
        },
        end: {
          line: 190,
          column: 66
        }
      },
      "19": {
        start: {
          line: 202,
          column: 26
        },
        end: {
          line: 213,
          column: 1
        }
      },
      "20": {
        start: {
          line: 210,
          column: 20
        },
        end: {
          line: 210,
          column: 87
        }
      },
      "21": {
        start: {
          line: 215,
          column: 33
        },
        end: {
          line: 220,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 34,
            column: 11
          },
          end: {
            line: 34,
            column: 12
          }
        },
        loc: {
          start: {
            line: 34,
            column: 20
          },
          end: {
            line: 34,
            column: 41
          }
        },
        line: 34
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 58,
            column: 13
          },
          end: {
            line: 58,
            column: 14
          }
        },
        loc: {
          start: {
            line: 58,
            column: 22
          },
          end: {
            line: 58,
            column: 76
          }
        },
        line: 58
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 70,
            column: 17
          },
          end: {
            line: 70,
            column: 18
          }
        },
        loc: {
          start: {
            line: 70,
            column: 26
          },
          end: {
            line: 70,
            column: 56
          }
        },
        line: 70
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 108,
            column: 13
          },
          end: {
            line: 108,
            column: 14
          }
        },
        loc: {
          start: {
            line: 108,
            column: 22
          },
          end: {
            line: 108,
            column: 69
          }
        },
        line: 108
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 190,
            column: 13
          },
          end: {
            line: 190,
            column: 14
          }
        },
        loc: {
          start: {
            line: 190,
            column: 22
          },
          end: {
            line: 190,
            column: 66
          }
        },
        line: 190
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 210,
            column: 11
          },
          end: {
            line: 210,
            column: 12
          }
        },
        loc: {
          start: {
            line: 210,
            column: 20
          },
          end: {
            line: 210,
            column: 87
          }
        },
        line: 210
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 34,
            column: 20
          },
          end: {
            line: 34,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 20
          },
          end: {
            line: 34,
            column: 31
          }
        }, {
          start: {
            line: 34,
            column: 35
          },
          end: {
            line: 34,
            column: 41
          }
        }],
        line: 34
      },
      "1": {
        loc: {
          start: {
            line: 58,
            column: 44
          },
          end: {
            line: 58,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 44
          },
          end: {
            line: 58,
            column: 59
          }
        }, {
          start: {
            line: 58,
            column: 63
          },
          end: {
            line: 58,
            column: 73
          }
        }],
        line: 58
      },
      "2": {
        loc: {
          start: {
            line: 70,
            column: 26
          },
          end: {
            line: 70,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 70,
            column: 45
          },
          end: {
            line: 70,
            column: 50
          }
        }, {
          start: {
            line: 70,
            column: 53
          },
          end: {
            line: 70,
            column: 56
          }
        }],
        line: 70
      },
      "3": {
        loc: {
          start: {
            line: 108,
            column: 38
          },
          end: {
            line: 108,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 108,
            column: 38
          },
          end: {
            line: 108,
            column: 53
          }
        }, {
          start: {
            line: 108,
            column: 57
          },
          end: {
            line: 108,
            column: 67
          }
        }],
        line: 108
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3b4528e91152aea9d51e3c85d6c69c0d80da2019"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ul1gwc062 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ul1gwc062();
var _ref = (cov_ul1gwc062().s[0]++, _stylingConstants.default),
  spacing = _ref.spacing,
  color = _ref.color,
  font = _ref.font,
  mediaQueries = _ref.mediaQueries;
var Wrapper = exports.Wrapper = (cov_ul1gwc062().s[1]++, _styledComponents.default.div.attrs({
  className: "stx-ReportManagement"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: center;\n  padding-bottom: ", ";\n  ", "\n  .disabled {\n    &.report-btn-generate button {\n      color: ", ";\n    }\n    &.report-btn-view-pdf button {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"])), spacing.medium, mediaQueries.desktop(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    padding-bottom: ", ";\n  "])), spacing.medium), color.disabledText, color.disabledBackground, color.disabledText));
var FlexReportAreaWrapper = exports.FlexReportAreaWrapper = (cov_ul1gwc062().s[2]++, _styledComponents.default.div.attrs({
  className: 'stx-FlexReportArea'
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  width: ", ";\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: ", ";\n  position: relative;\n  ", ";\n"])), function (props) {
  cov_ul1gwc062().f[0]++;
  cov_ul1gwc062().s[3]++;
  return (cov_ul1gwc062().b[0][0]++, props.width) || (cov_ul1gwc062().b[0][1]++, '100%');
}, spacing.medium, mediaQueries.desktop(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    margin-top: ", ";\n  "])), spacing.small)));
var GenerateBtnArea = exports.GenerateBtnArea = (cov_ul1gwc062().s[4]++, _styledComponents.default.div.attrs({
  className: 'stx-ReportGenerateBtnArea'
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  margin-top: ", ";\n  ", ";\n"])), spacing.medium, mediaQueries.desktop(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n    margin-top: 0;\n  "])))));
var ButtonWrapper = exports.ButtonWrapper = (cov_ul1gwc062().s[5]++, _styledComponents.default.div.attrs({
  className: function className(props) {
    cov_ul1gwc062().f[1]++;
    cov_ul1gwc062().s[6]++;
    return "stx-GenerateButton ".concat((cov_ul1gwc062().b[1][0]++, props.isDisable) && (cov_ul1gwc062().b[1][1]++, 'disabled'), " ");
  }
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  padding: ", " ", ";\n  font-size: ", ";\n  button {\n    line-height: ", ";\n    cursor: pointer;\n    font-weight: bold;\n    ", ";\n    &:hover {\n      opacity: ", ";\n    }\n  }\n  &.report-btn-generate {\n    padding: ", " 0;\n    button {\n      padding: 0;\n      background: ", ";\n      color: ", ";\n      text-align: left;\n    }\n  }\n"])), spacing.medium, spacing.medium, font.sizeM, spacing.medium, mediaQueries.tablet(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      min-width: 150px;\n    "]))), function (props) {
  cov_ul1gwc062().f[2]++;
  cov_ul1gwc062().s[7]++;
  return !props.isDisable ? (cov_ul1gwc062().b[2][0]++, '0.6') : (cov_ul1gwc062().b[2][1]++, '1');
}, spacing.medium, color.transparent, color.boxBackground));
var ExportType = exports.ExportType = (cov_ul1gwc062().s[8]++, {
  EXCEL: 'XLS',
  PDF: 'PDF'
});
var SectionHeading = exports.SectionHeading = (cov_ul1gwc062().s[9]++, _styledComponents.default.div.attrs({
  className: "stx-ReportManagement-Heading"
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  padding-top: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: normal;\n  margin: 0;\n  color: ", ";\n  width: 100%;\n  display: flex;\n  align-items: center;\n  height: ", ";\n  flex-wrap: wrap;\n"])), spacing.medium, font.weightBold, font.sizeL, font.sizeL, color.baseText, spacing.medium));
var DropDownWrapper = exports.DropDownWrapper = (cov_ul1gwc062().s[10]++, _styledComponents.default.div.attrs({
  className: function className(props) {
    cov_ul1gwc062().f[3]++;
    cov_ul1gwc062().s[11]++;
    return "stx-Dropdown ".concat((cov_ul1gwc062().b[3][0]++, props.isDisable) && (cov_ul1gwc062().b[3][1]++, 'disabled'));
  }
})(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  height: 50%;\n  width: 100%;\n  margin: 0 1rem;\n  position: relative;\n\n  select {\n    padding-left: ", ";\n    border: 1px solid ", ";\n  }\n\n  ", ";\n"])), spacing.small, color.grey, mediaQueries.desktop(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n    width: 350px;\n  "])))));
var SplitButtonTextWrapper = exports.SplitButtonTextWrapper = (cov_ul1gwc062().s[12]++, _styledComponents.default.div.attrs({
  className: 'stx-SplitButtonText'
})(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0 ", ";\n  font-size: ", ";\n"])), spacing.small, font.sizeMS));
var AlertMessageWrapper = exports.AlertMessageWrapper = (cov_ul1gwc062().s[13]++, _styledComponents.default.div.attrs({
  className: 'stx-AlertMessage'
})(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0 ", ";\n  font-size: ", ";\n  font-weight: normal;\n  display: flex;\n  align-items: center;\n  .text {\n    padding: 0 ", ";\n  }\n"])), spacing.medium, font.sizeMS, spacing.small));
var AlertNoReportAvailable = exports.AlertNoReportAvailable = (cov_ul1gwc062().s[14]++, _styledComponents.default.div.attrs({
  className: 'stx-ReportManagement-AlertNoReportAvailable'
})(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n  padding: ", ";\n  padding-top: ", ";\n"])), spacing.medium, spacing.large));
var AlertOrderDateCompatibleWrapper = exports.AlertOrderDateCompatibleWrapper = (cov_ul1gwc062().s[15]++, _styledComponents.default.div.attrs({
  className: 'stx-alertOrderDateCompatible'
})(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: ", ";\n  bottom: -1rem;\n  font-style: italic;\n"])), font.sizeXs));
var ReportSummaryWrapper = exports.ReportSummaryWrapper = (cov_ul1gwc062().s[16]++, _styledComponents.default.div.attrs({
  className: 'stx-Summary'
})(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2.default)(["\n  margin-left: ", ";\n  .summary-text {\n    font-weight: ", ";\n    font-size: ", ";\n    margin-left: ", ";\n    font-style: italic;\n  }\n  svg {\n    -webkit-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n  }\n"])), spacing.medium, font.weightRegular, font.sizeMS, spacing.xsmall));
var ResetButton = exports.ResetButton = (cov_ul1gwc062().s[17]++, (0, _styledComponents.default)(_button.default).attrs({
  className: 'g-ReportFilter-button-resetFilters'
})(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  margin-left: -5px;\n  margin-right: ", ";\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  text-decoration: none;\n  cursor: pointer;\n  &:not(:disabled) {\n    color: ", ";\n  }\n  &:hover,\n  &:focus {\n    background-color: transparent;\n  }\n  .text {\n    margin-left: 5px;\n    text-decoration: none;\n  }\n"])), spacing.medium, function (props) {
  cov_ul1gwc062().f[4]++;
  cov_ul1gwc062().s[18]++;
  return (0, _get.default)(props, 'theme.linkTextColor', '#3291f2');
}));
var HelpButton = exports.HelpButton = (cov_ul1gwc062().s[19]++, _styledComponents.default.span.attrs({
  className: 'g-SectionHeading-HelpButton'
})(_templateObject18 || (_templateObject18 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  right: 2rem;\n  display: grid;\n  grid-auto-flow: column;\n  grid-column-gap: 10px;\n  color: ", ";\n  font-size: 1rem;\n  cursor: pointer;\n"])), function (props) {
  cov_ul1gwc062().f[5]++;
  cov_ul1gwc062().s[20]++;
  return (0, _get.default)(props.theme, 'dashboard.contentTextColor', color.boxBackground);
}));
var DateFilterWrapper = exports.DateFilterWrapper = (cov_ul1gwc062().s[21]++, (0, _styledComponents.default)(_ReportDateFilter.default).attrs({
  className: 'g-ReportFilter-DateWrapper'
})(_templateObject19 || (_templateObject19 = (0, _taggedTemplateLiteral2.default)(["\n  margin-right: ", ";\n  min-width: 170px;\n"])), spacing.medium));